import './BetbookNewPost.less';

import PopupNg from '@/ui/PopupNg';
import { navigate } from '@/routing';
import i18n from 'nike-ui/src/common/i18n';
import React, { useEffect, useState } from 'react';
import { getConfigProperty } from '@/common/oldMobile';
import { dispatch, useReframe } from 'nike-re-framejs';

import AddIcon from 'nike-ui/src/icons/svg/add-icon-sv.svg';
import DeleteIcon from '@/icons/DeleteIcon';
import { Button } from 'nike-ui/src/components/button/Button';
import BetbookPostTicket from '@/betbook/views/BetbookPostTicket';
import BetbookPostEditorNew from 'nike-ui/src/components/betbook/betbookPostEditor/BetbookPostEditor';
import AnalysisPostEditor from 'nike-ui/src/components/betbook/betbookPostEditor/AnalysisPostEditor';
import { getTicket } from '@/mytickets/detail/api';
import { errors$, newPostBet$ } from '@/betbook/subs';
import { ticketDetail$ } from '@/mytickets/detail/subs';
import { ticketusQuickTickets$ } from '@/mytickets/overview/subs';
import { accountUserData$, accountVerificationStatus$ } from '@/account/subs';

import { clearQuickTickets } from '@/mytickets/overview/handlers';
import { addTicketToTopic, forumTopicReset, getTopicTickets } from '@/forum/ticketpicker/handlersAndSubs';
import { loadBoxByBetIds } from '@/nikeone/handlers';
import { setNewPostTicket } from '@/mytickets/detail/handlers';
import { BetbooPostTypeOptions, POST_ANALYSIS, POST_TICKET } from 'nike-ui/src/components/betbook/constants';
import EmptyState from 'nike-ui/src/components/empty-state/EmptyState';
import { betbookListRoute, betbookNewRoute } from '@/betbook/utils';
import { COMMUNITY_LOBBY } from '@/routing/routes';
import { isProfileTicketArenaEnabled } from 'nike-ui/src/profiles';

function betbookCancelPost() {
    PopupNg.dispatcher.open('dialog/message', {
        className: 'warn',
        titleIcon: 'sad-face',
        titleText: i18n('popup.info'),
        bodyText: i18n('betbook.cancel.post.dialog'),
        confirmText: i18n('commons.button.ano'),
        cancelText: i18n('commons.button.nie'),
        onConfirm: () => dispatch(['history_back', COMMUNITY_LOBBY])
    });
}

interface BetbookNewPostProps {
    post?;
    type: BetbooPostTypeOptions;
    ticketHash?: string;
    edit?: boolean;
}
function BetbookNewPost({ post, type, ticketHash, edit = false }: BetbookNewPostProps) {
    const { derefSub, subscribe } = useReframe();
    const [postType, setPostType] = useState<BetbooPostTypeOptions>(type || POST_ANALYSIS);
    const [clientError, setClientError] = useState(false);
    const serverError = subscribe(errors$);
    const topic = 'betbook:new-analysis';
    const postBet = subscribe(newPostBet$);
    const userData = subscribe(accountUserData$);
    const { betId, betSelectionCode } = postBet || {};
    const allTickets = subscribe(ticketusQuickTickets$);
    const isTicketPicked = subscribe(getTopicTickets(topic))?.[0];
    const oddsLimit = getConfigProperty('betbook.ticketOddsLimit');
    const ticketFromHash = ticketHash ? derefSub(ticketDetail$(ticketHash)) : null;
    const postTicket =
        post || (postBet && isTicketPicked)
            ? subscribe(ticketDetail$(post?.ticket?.hash || postBet?.ticketHash))
            : null;
    const ticketId = postTicket ? postTicket.ticketId : null;
    const verificationStatus = subscribe(accountVerificationStatus$);
    const shouldDisplayPage = (post && post.author.nickname !== userData.nickname) || verificationStatus !== 'VERIFIED';

    useEffect(() => {
        return () => dispatch(clearQuickTickets);
    }, []);

    useEffect(() => {
        if (postType) setClientError(false);
        if (postType === POST_TICKET) {
            dispatch(['ticketus/quicktickets/initialize', 'prematch', ['registered'], null]);
        }
    }, [postType]);

    useEffect(() => {
        if (postBet) {
            if (postBet.betId) {
                dispatch(loadBoxByBetIds([postBet.betId]));
            }
            if (postBet.ticketHash) {
                getTicket(postBet.ticketHash);
            }
        }
    }, [postBet]);

    useEffect(() => {
        if (ticketFromHash) dispatch(addTicketToTopic('betbook:new-analysis', ticketFromHash));
    }, [ticketFromHash]);

    useEffect(() => {
        dispatch(setNewPostTicket(ticketHash));
    }, [ticketHash]);

    if (!userData.nickname) {
        return (
            <EmptyState
                text={i18n('betbook.newPost.loginRequired')}
                buttonText={i18n('jsp.login.Prihlasit')}
                buttonClassName="nui-button secondary"
                buttonOnClick={() => dispatch(['login.openScreen'])}
            />
        );
    }
    if (shouldDisplayPage) {
        navigate(betbookListRoute(postType));
        return null;
    }

    function onPostTypeChange(type) {
        navigate(betbookNewRoute(type));
    }

    function openTicketDetail(hash) {
        PopupNg.dispatcher.open('betbook/ticketDetailPopup', { hash });
    }

    function createPostPopUp(postType) {
        PopupNg.dispatcher.show({
            style: 'success2',
            title: 'betbook.post.createPostPopup.title',
            messages: 'betbook.post.createPostPopup.text',
            close: ['navigate', betbookListRoute(postType)]
        });
    }

    function editPostPopUp(postType, postId) {
        PopupNg.dispatcher.show({
            style: 'success2',
            title: 'betbook.post.editPostPopup.title',
            messages: 'betbook.post.editPostPopup.text',
            close: postId ? ['history_back', COMMUNITY_LOBBY] : ['navigate', betbookListRoute(postType)]
        });
    }
    return (
        <PostEditorWrapper
            // @ts-expect-error typescript
            allTickets={allTickets}
            createPostPopUp={createPostPopUp}
            editPostPopUp={editPostPopUp}
            error={serverError}
            onPostTypeChange={onPostTypeChange}
            openTicketDetail={openTicketDetail}
            post={post || null}
            postType={postType}
            setError={setClientError}
            setPostType={setPostType}
            ticketId={ticketId}
            userData={userData || null}
            mobile
            onCancelButtonClick={betbookCancelPost}
        >
            {betId || postType === POST_TICKET ? (
                <BetbookNewPostTicket
                    // @ts-expect-error typescript
                    betId={betId}
                    topic={topic}
                    editActive={post}
                    postType={postType}
                    oddsLimit={oddsLimit}
                    postTicket={postTicket}
                    betSelectionCode={betSelectionCode}
                    error={(serverError || clientError) && (!postTicket || !postTicket?.size)}
                    edit={edit}
                />
            ) : null}
        </PostEditorWrapper>
    );
}

function BetbookNewPostTicket({ topic, postType, postTicket, editActive, oddsLimit, error, edit }) {
    function openTicketPickerDialog() {
        PopupNg.dispatcher.open('ticketEditor/popup', {
            oddsLimit,
            postType: postType,
            status: ['registered'],
            topic,
            type: 'prematch'
        });
    }

    return postTicket ? (
        <div className="betbook-new-post-ticket">
            {/*@ts-expect-error typescript*/}
            <BetbookPostTicket ticket={postTicket} editorTicket />
            {editActive ? null : (
                <div
                    className="betbook-search-detailed-bets-delete-icon betbook-delete-icon-margin"
                    onClick={() => dispatch(forumTopicReset(topic))}
                >
                    {/*@ts-expect-error typescript*/}
                    <DeleteIcon />
                </div>
            )}
        </div>
    ) : postType === POST_TICKET && !edit ? (
        <>
            <AttachmentButton onClick={openTicketPickerDialog} text={i18n('betbook.newPost.chooseTicket')} />
            {error ? (
                <div className="attachment-error ticket-attachment-error">{i18n('betbook.newPost.error.ticket')}</div>
            ) : null}
        </>
    ) : null;
}

function AttachmentButton({ onClick, text, disabled = false }) {
    return (
        <Button
            className="betbook-attachment-button blue"
            label={text}
            icon={AddIcon}
            onClick={onClick}
            disabled={disabled}
        />
    );
}

const PostEditorWrapper = ({
    children,
    createPostPopUp,
    editPostPopUp,
    error,
    onPostTypeChange,
    openTicketDetail,
    post,
    postType,
    setError,
    setPostType,
    ticketId,
    userData,
    onCancelButtonClick
}) => {
    return isProfileTicketArenaEnabled() && postType === POST_ANALYSIS ? (
        <AnalysisPostEditor
            createPostPopUp={createPostPopUp}
            editPostPopUp={editPostPopUp}
            error={error}
            openTicketDetail={openTicketDetail}
            post={post || null}
            ticketId={ticketId}
            userData={userData || null}
            mobile
            onCancelButtonClick={onCancelButtonClick}
            onPortalError={undefined}
            setTicketHash={undefined}
            setTicketId={undefined}
            setTicketListVisible={undefined}
        >
            {children}
        </AnalysisPostEditor>
    ) : (
        <BetbookPostEditorNew
            createPostPopUp={createPostPopUp}
            editPostPopUp={editPostPopUp}
            error={error}
            onPostTypeChange={onPostTypeChange}
            openTicketDetail={openTicketDetail}
            post={post}
            postType={postType}
            setError={setError}
            setPostType={setPostType}
            ticketId={ticketId}
            userData={userData}
            mobile
            onCancelButtonClick={onCancelButtonClick}
            onPortalError={undefined}
            setTicketHash={undefined}
            setTicketId={undefined}
            setTicketListVisible={undefined}
        >
            {children}
        </BetbookPostEditorNew>
    );
};

export default BetbookNewPost;
